/* eslint-disable import/no-cycle */
import api from './api.service';

function teacherIndex(params) {
  return api.get('/campaigns/teachers', params);
}

function schoolResultIndex(params) {
  return api.get('/campaigns/schools/result', params);
}

function get(id, params) {
  return api.get(`/campaigns/${id}`, params);
}

function create(params) {
  return api.post('/campaigns', params);
}

function update(id, params) {
  return api.put(`/campaigns/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/campaigns/${id}`, params);
}

function removeReservation(params) {
  return api.delete('/campaigns/teachers-booked', params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

function checkTeacherBooks(params) {
  return api.get('/campaigns/check-teacher-books', params);
}

export const campaignsService = {
  teacherIndex,
  schoolResultIndex,
  get,
  create,
  update,
  remove,
  save,
  removeReservation,
  checkTeacherBooks,
};
